import { Report } from 'src/common-services/types/report-types'
import { IS_DEV, IS_LOCAL } from 'src/config'

export enum PrintFormat {
  PDF = 'pdf',
  PNG = 'png',
  PNG_PREVIEW = 'png_preview',
}

export type PrintConfig = {
  url: string
  format: PrintFormat
}

export type PrintPage = {
  config: PrintConfig
  report: Report
}

export type UpdatePreview = {
  config: PrintConfig
  reportId: Report['id']
}

export const PrintURL =
  `${
    IS_LOCAL
      ? `http://host.docker.internal:3001`
      : IS_DEV
        ? `https://app.dev.alphamap.com`
        : `https://app.alphamap.com/`
  }` + `/reports/presentation/print`
